import { Flex, theme, Typography } from '@styles';
import { func, shape } from 'prop-types';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { avatars } from '../../SettingsPage.layoutProps';

const ChooseAvatarModal = ({ activeElement, setActiveElement }) => {
  const { i18n } = useTranslation();

  const memoAvatars = useMemo(() =>
    avatars?.map(
      (element) => (
        <Flex
          key={element.id}
          alt="avatar"
          backgroundImage={element.image}
          backgroundRepeat="no-repeat"
          backgroundSize="cover"
          borderRadius="50%"
          flexShrink={0}
          height="113px"
          onClick={() => setActiveElement(element)}
          width="113px"
          {...(activeElement.id === element.id && {
            border: 5,
            borderColor: theme.colors.schoolBusYellow[100],
            borderStyle: 'solid',
          })}
        />
      ),
      [avatars, activeElement]
    )
  );

  return (
    <Flex flexDirection="column" gap={24} overflow="scroll" p={40}>
      <Typography
        color={theme.colors.white[100]}
        variant="MS-semibold-s24-lh36"
      >
        {i18n.t('ProfilePage.ChooseAvatar')}
      </Typography>
      <Flex flexWrap="wrap" gap={24} justifyContent="center">
        {memoAvatars.map((el) => el)}
      </Flex>
    </Flex>
  );
};

ChooseAvatarModal.propTypes = {
  activeElement: shape.isRequired,
  setActiveElement: func.isRequired,
};

export default ChooseAvatarModal;
